<template>
  <div id="project-header">
    <div class="vx-row" v-if="isNewPage">
      <div class="vx-col w-full">
        <vx-card>
          <h6 class="success bold">RIESGO CREDITICIO</h6>
          <vs-list>
            <vs-list-item title="Versión de modelo:">{{ translateRiskModelVersions(project.finance.risk_model_version)||"--" }}</vs-list-item>
          </vs-list>
          <div>
            <AssignLoanResponsibles :type="'credit_risk'" :loan="project"></AssignLoanResponsibles>
          </div>
          <div>
            <LoanRelationWApplicantIFC :loan="project"></LoanRelationWApplicantIFC>
          </div>
          <vs-divider>Notificaciones</vs-divider>
          <!-- informacion del telefono del solicitante -->
          <!-- <user-phone-status
          class="w-full"
              :user-id="project.client.user.id"
          /> -->
          <div class="vx-row">
            <div class="vx-col w-full">
              <!-- notificar de llamada al solicitante -->
              <applicant-notification-button
                :user-id="project.client.user.id"
              />
            </div>
            <div class="vx-col w-full">
              <!-- notificar al os de llamada -->
              <os-notification-button
                :project="project"
              />
            </div>
          </div>

          <vs-divider>Acciones</vs-divider>
          <div class="flex justify-between">
            <!-- cambiar de proveedor -->
            <!-- <project-supplier-selector
              :supplier.sync="project.supplier"
              :project_id="project.id"></project-supplier-selector> -->

              <!-- botones -->
              <div class="flex">
                <!-- botón de rechazo -->
                <div>
                  <LoanRejectionButton
                      :loan-id="project.id"/>
                </div>

                <template v-if="isProjectNotUndefined">
                  <project-archive-button
                      class="ml-1"
                      :project="project"></project-archive-button>
                </template>
    
                <vx-tooltip text="Reactivar proyecto">
                  <vs-button
                      color="danger"
                      icon="reply"
                      class="ml-1"
                      @click="reactiveProject(project.id)"
                      v-if="project.resolution_date != null">
                  </vs-button>
                </vx-tooltip>
              </div>
          </div>
          <vs-row class="gap-2 mt-6">
            <vx-tooltip title="Solicitar OS" text="Solicita un nuevo obligado solidario para la solicitud. Notifica al solicitante vía email para que lo agregue desde su plataforma.">
              <vs-button
                size="small"
                color="black"
                v-if="!isMoral && project.status < 4"
                @click="requestNewGuaranteeForLoan()">
                Solicitar nuevo OS
              </vs-button>
            </vx-tooltip>
            <vs-button
                size="small"
                :disabled="project.resolution_date != null" v-if="project.status === 2 || project.status === 4 || project.status === 1"
                @click="preapprove()">
              Pre-Aprobar
            </vs-button>
            <vx-tooltip title="Primer revisión completa" text="Ya se validó la información de la solicitud y se ejecutó el modelo. Sin documentación">
              <vs-button size="small" color="warning" @click.stop="postLoanReviewDateWithoutDocuments">Primer revisión completa</vs-button>
            </vx-tooltip>
            <vx-tooltip v-if="project.status == 4 && project.approved_date != null" title="Ofertar crédito" text="Se envía al cliente la propuesta del crédito (tasa, plazo, monto, enganche, etc.)">
              <vs-button size="small" color="danger" @click.stop="requestPostLoanOffer">Ofertar crédito</vs-button>
            </vx-tooltip>
            <vx-tooltip title="Regresar solicitud" text="Requiere que el solicitante o proveedor corrija algo de la documentación de la solicitud">
              <vs-button
                size="small"
                v-if="canReturnToSupplier"
                @click="returnToSupplierRequest()">
              Regresar solicitud
            </vs-button>
            </vx-tooltip>
            <LoanScreenedButton
                v-if="project.application_screened_at != null && project.status <= 4"
                :loan-id="project.id"
                :isScreened="false" />
            <vx-tooltip title="Aprobar" text="La solicitud tiene el vobo del área de riesgo para ser aprobada">
              <vs-button
                  size="small"
                  :disabled="project.resolution_date != null"
                  v-if="canApprove" @click="showDialogApprove = true">
                Aprobar
              </vs-button>
            </vx-tooltip>
            <vs-button
                size="small"
                v-if="project.status === 4 || project.approved_date != null"
                :disabled="project.resolution_date != null"
                @click="publish()">
              Publicar
            </vs-button>
            <!-- primary buttons end -->

            <!-- secondary buttons -->
            <payment-card-options-button
                :initialPaymentUrl.sync="project.finance.initial_payment_url"
                :project_id="project.id"
                :project-resolution="project.resolution_date"
                :initialPaymentAmount="project.finance.initial_payment"
                v-if="project.status === 4"/>

            <vs-button
                size="small"
                color="#303f9f"
                v-if="canCloneProject"
                @click="cloneProjectRequest()">
              Clonar proyecto
            </vs-button>
            <!-- RECORDATORIO PARA CUANDO EL CORREO ESTABA MAL -->
            <vx-tooltip v-if="showApplicantPasswordReminder" title="Crear contraseña para solicitante" text="Reenvia el correo al solicitante con link para crear contraseña e iniciar onboarding.">
              <vs-button size="small" color="primary" @click.stop="requestEmailToApplicant">Enviar link contraseña</vs-button>
            </vx-tooltip>
          </vs-row>
        </vx-card>
      </div>
    </div>

    <vs-card
        v-else
        class="mb-5">
      <template slot="header">
        <div class="flex">
          <h2 class="flex-1">{{ project.alias || 'Sin Alias' }}</h2> 
          <vs-chip v-if="project.pgm_potential_applicant" color="#f44336">
            <strong>{{ project.pgm_potential_applicant.program_info.name }}</strong>
          </vs-chip>
          <button-mark-project-as-recommended
              class="flex-none"
              :value="(project.public_top || 0)"
              :project_id="project.id"/>
        </div>
      </template>

      <div class="container">
        <div class="row">
          <div class="col-md-6">

            <div class="row mb-2">
              <strong>Tipo de persona: </strong><span class="ml-2"> {{ personType }}</span>
            </div>

            <div class="row mb-5">
              <strong>Estatus del proyecto: </strong><span class="ml-2"> {{ statusName() }}</span>
            </div>
            <div class="row mb-5">
              <div class="col-12 p-0">
                <strong>Producto: </strong><span class="ml-2"> {{ translateProductType(project.finance.financial_product_id) }}</span>
              </div>
              <div class="col-12 p-0">
                <strong>Financiamiento: </strong><span class="ml-2"> {{ translateCrowdfundingLoanType(project.finance.crowdfunding_loan_type) }}</span>
              </div>
              <div class="col-12 p-0">
                <strong>Tipo de crédito: </strong><span class="ml-2"> {{ translateLoanType(project.finance.loan_type) }}</span>
              </div>
            </div>

            <div class="row mb-5">
              <div class="flex">
                <p class="text-sm mb-0" v-if="!editLoanStep">
                    Onboarding: <span class="bold">{{ project.loan_request_step||"--"  }}</span>
                </p>
                <div class="w-full" v-else>
                  <vs-select
                    class="w-full"
                    v-model.lazy="stepSelected"
                    label="Onboarding"
                    name="stepSelected"
                    placeholder="Seleccione una opción">
                    
                    <vs-select-item
                        :key="index"
                        :value="item.key"
                        :text="item.value"
                        v-for="(item,index) in step_options"
                        class="w-full"
                    />
                  </vs-select>
                </div>
                <vs-button 
                    v-if="!editLoanStep"
                    @click.stop="editLoanStep = true" 
                    icon-pack="feather" 
                    icon="icon-edit" 
                    color="success" 
                    type="line" 
                    style="margin: 1rem 0px 0px 5px"></vs-button>
                <vs-button 
                    v-else
                    @click.stop="requestUpdateLoanStep()" 
                    icon-pack="feather" 
                    icon="icon-save" 
                    color="success" 
                    type="line" 
                    style="margin: 1.5rem 0px 0px 5px"></vs-button>
              </div>
              <a class="text-sm" href="https://docs.google.com/spreadsheets/d/1_P1FFJHGD7icuhXJ5Rlhl8cXhwvWCCLklw3rpPtgz3w/edit?usp=sharing" target="_blank">
                Consulta los pasos de onboarding y sus condiciones.
              </a>
            </div>

            <div class="row mb-5">
              <loan-geolocation-component
                :geolocation="project.geolocation_at_project_creation"/>
            </div>

            <div class="row">
              <!-- informacion del telefono del solicitante -->
              <user-phone-status
                  :user-id="project.client.user.id"
              />
            </div>

            <!-- Datos sobre la verificación de identidad del usuario -->
            <div class="row">
              <user-identity-verification :user-id="project.client.user.id"/>
            </div>

            <!-- MENSAJE DE NOTIFICACIÓN PARA EL SOLICITANTE -->
            <div class="row">
              <applicant-notification-button
                :user-id="project.client.user.id"
              />
            </div>
            <!-- supplier chip selector -->
            <div class="row">
              <div class="flex gap-2">
              <!-- INFORMACIÓN DEL AGENTE -->
              <supplier-agent-information
                v-if="project.supplier_id != null"
                  class="mt-2"
                  :projectId="project.id"></supplier-agent-information>
              <!-- INFORMACIÓN DEL AGENTE -->
              <project-supplier-selector
                  v-if="project.supplier_id != null"
                  :supplier.sync="project.supplier"
                  :project_id="project.id"></project-supplier-selector>

              <!-- <vx-tooltip text="Rechazar proyecto">
                <vs-button
                    color="danger"
                    v-if="project.resolution_date == null" @click="reject()"
                    icon="block"></vs-button>
              </vx-tooltip> -->

              <template v-if="isProjectNotUndefined">
                <project-archive-button
                    :project="project"></project-archive-button>
              </template>

              <vx-tooltip text="Reactivar proyecto">
                <vs-button
                    color="danger"
                    icon="reply"
                    @click="reactiveProject(project.id)"
                    v-if="project.resolution_date != null">
                </vs-button>
              </vx-tooltip>
              <!-- danger buttons end -->
            </div>
            </div>
          </div>
          <div class="col-md-6">
            <client-max-loan-amount-allowed-input
                :applicant-id="project.client.id"
                :value="project.client.max_loan_amount_allowed_mxn" />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 flex">
            <project-events :project_id="project.id" :status="project.status"></project-events>
            <user-emails-sent-list
                v-if="project.client.user.email"
                class="mt-2 mr-2"
                :userEmail="project.client.user.email"
                :btnConfig="btnConfig"/>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <!-- STATUS DE COBRANZA -->
            <!-- TODO-DELETE-IA 28/02/2024 ESTA FUNCION SE VA -->
            <!-- <div v-if="project.resolution_date == null">
              <template v-if="!showDropDownList">
                Estatus Cobranza
                <span
                    class="badge badge-success"
                    @click="showDropDownList = true">
                  {{ assetCreditStatusName(project.finance.asset_status, project.finance.credit_status) }}
                  </span>
              </template>
              <template v-else>
                <vs-select
                    class="w-full"
                    @change="updateCreditStatus()"
                    v-model="project.finance.credit_status"
                    label="Estatus cobranza">
                  <vs-select-item
                      v-for="cs in creditStatus"
                      :key="cs.id"
                      :text="cs.name"
                      :value="cs.id">
                  </vs-select-item>
                </vs-select>
              </template>
            </div> -->
            <!-- STATUS DE COBRANZA -->

            <project-funding-progress v-if="project.fund === 1" :project="project"></project-funding-progress>
            <vs-button
                icon="inventory_2"
                class="md-accent" v-if="project.resolution_date != null">
              Proyecto archivado
            </vs-button>

            <ul class="split-list">
              <template v-if="project.splits.length > 0">
                <li v-for="split in project.splits" :key="split.id">
                  <router-link :to="`/project/${split.id}`">
                    {{ split.alias }}
                  </router-link>
                </li>
              </template>
            </ul>
          </div>

          <div class="col-md-12 mt-6 mb-1">
            <template v-if="isNewApplicant">
              <vs-chip transparent color="primary">
                <span class="bold text-xs">Nuevo solicitante</span>
              </vs-chip>
            </template>
            <template v-else>
              <div class="row">
                <vs-chip transparent color="danger" v-if="hasRejectedProjects">
                  <span class="bold text-xs">Solicitante con proyectos previos rechazados</span>
                </vs-chip>
                <vs-chip transparent color="#7e57c2" v-else-if="hasNotRejectedNotRunningProjects">
                  <span class="bold text-xs">Solicitante con proyectos no rechazados y sin créditos</span>
                </vs-chip>
                <vs-chip color="primary" v-else-if="hasRunningProjects">
                  <span class="bold text-xs">Solicitante con proyecto vigente (extensión)</span>
                </vs-chip>
              </div>
              <p>
                <span class="bold text-dark">PIDS:</span>
                <span v-for="(p, idx) in relatedProjectsList" :key="p.id">
                    <router-link v-if="p.id !== project.id" :to="`/project/${p.id}`" target="_blank">
                    {{ idx < relatedProjects.total - 1 ? `${p.id},` : p.id }}
                    </router-link>
                    <span class="text-dark" v-else>
                        {{ idx < relatedProjects.total - 1 ? `${p.id},` : p.id }}
                    </span>
                  </span>
              </p>
            </template>
          </div>

          <vs-row class="gap-2 mt-6">
            <vs-button
                size="small"
                v-if="project.status === 4"
                :disabled="project.resolution_date != null"
                @click="publish()">
              Publicar
            </vs-button>
            <!-- primary buttons end -->

            <!-- secondary buttons -->
            <payment-card-options-button
                :initialPaymentUrl.sync="project.finance.initial_payment_url"
                :project_id="project.id"
                :project-resolution="project.resolution_date"
                :initialPaymentAmount="project.finance.initial_payment"
                v-if="project.status === 4"/>

            <vx-tooltip title="Regresar solicitud" text="Requiere que el solicitante o proveedor corrija algo de la documentación de la solicitud">
              <vs-button
                  size="small"
                  v-if="canReturnToSupplier"
                  @click="returnToSupplierRequest()">
                Regresar solicitud
              </vs-button>
            </vx-tooltip>
            <vs-button
                size="small"
                color="#303f9f"
                v-if="canCloneProject"
                @click="cloneProjectRequest()">
              Clonar proyecto
            </vs-button>
            <vx-tooltip v-if="canReturnToRisk" color="warning" title="ENVIAR A RIESGO CREDITICIO" text="Marca la solicitud como documentación completa y la manda a revisión con el equipo de riesgo crediticio.">
              <vs-button
                  size="small" color="warning"
                  v-if="canReturnToRisk"
                  @click="requestReturnToRisk()">
                  ENVIAR A RIESGO CREDITICIO
              </vs-button>
            </vx-tooltip>
            <LoanScreenedButton
              :loan-id="project.id"
              :isScreened="true" />

            <!-- RECORDATORIO PARA CUANDO EL CORREO ESTABA MAL -->
            <vx-tooltip v-if="showApplicantPasswordReminder" title="Crear contraseña para solicitante" text="Reenvia el correo al solicitante con link para crear contraseña e iniciar onboarding.">
              <vs-button size="small" color="primary" @click.stop="requestEmailToApplicant">Enviar link contraseña</vs-button>
            </vx-tooltip>
          </vs-row>
        </div>
      </div>
    </vs-card>

    <!-- CARTERA VENCIDA DEL INSTALADOR -->
    <due-portfolio-supplier-stats
        v-if="!isNewPage && project.supplier_id != null"
        :realTime="true"
        :supplierId="project.supplier.id"/>

    <vs-popup :active.sync="showDialogApprove" title="Confirmación para aprobación de proyecto">
      <ul>
        <li><strong>Costo total:</strong> {{ project.finance.total_cost | currency }}</li>
        <li><strong>Enganche:</strong> {{ project.finance.deposit | currency }}</li>
        <li><strong>Plazo:</strong> {{ project.finance.term }} Meses</li>
        <li><strong>Tasa:</strong> {{ (project.finance.annual_interest_percentage * 100).toFixed(2) }} %</li>
        <li><strong>Periodo de entrega:</strong> {{ project.finance.delivery_term }} Meses</li>
        <li><strong>Pago Entrega:</strong> {{ project.finance.symbolic_payment | currency }}</li>
        <li><strong>Pago inicial:</strong> {{ project.finance.initial_payment | currency }}</li>
        <li><strong>Comisión administrativa:</strong> {{ project.finance.ensurance | currency }}</li>
        <li><strong>Comisión por fondeo:</strong> {{ project.finance.admon_comission |currency }}</li>
        <li><strong>Intereses financiados:</strong> {{ project.finance.financed_interests | currency }}</li>
        <li><strong>Mensualidad:</strong> {{ project.finance.monthly_payment | currency }}</li>
        <li><strong>Monto a financiar:</strong> {{ project.finance.financed_amount | currency }}</li>
      </ul>

      <div class="mt-6">
        <vs-button class="mr-2 small" color="dark" @click="showDialogApprove = false">Cerrar</vs-button>
        <vs-button class="mr-2 text-dark small" color="secondary" @click="showAmortTab()">Ver tabla de amortiamortización.</vs-button>
        <vs-button @click="confirmApproveHandler" class="small">Confirmar Aprobación</vs-button>
      </div>
    </vs-popup>


    <vs-popup :active.sync="commentsPrompt" :title="`Nota privada para proyecto: ${project.id} | ${project.alias}`">
      <div class="vx-row">
        <div class="vx-col w-full">
          <small><strong>NOTA:</strong> El proyecto <strong>{{ project.id }} | {{ project.alias }}</strong> tiene un
            costo mayor a <strong>{{ slas.max_total_cost_amount_to_no_deposit_mxn | currency }}</strong> y es necesario
            agregar por lo menos un <strong>{{ minPercentage }} de enganche</strong>, en caso de no necesitarlo deberá
            justificarlo en caja de texto siguiente.
          </small><br>
          <small>
            <strong>Información de proyecto:</strong>
            <ul>
              <li>Costo total (total_cost): <strong>{{ project.finance.total_cost | currency }}</strong></li>
              <li>Porcentaje de depósito
                (deposit_percentage):<strong>{{ (project.finance.deposit_percentage * 100).toFixed(2) }} %</strong>
              </li>
            </ul>
          </small>
        </div>
        <vs-divider></vs-divider>
        <div class="vx-col w-full mt-4 mb-4">
          <label>Comentarios</label>
          <vx-textarea name="reasons" v-model="reasons" height="300px"/>
        </div>
        <div class="flex flex-wrap-reverse items-center flex-grow" style="justify-content: space-evenly !important;">
          <vs-button :disabled="reasons === ''" @click="approve()" color="primary" type="filled">Confirmar aprobación
          </vs-button>
          <vs-button @click="commentsPrompt=false, reasons = '', showDialogApprove=false" color="danger" type="filled">
            Cancelar
          </vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import ProjectFundingProgress from "./ProjectFundingProgress";
import ButtonMarkProjectAsRecommended from "../ButtonMarkProjectAsRecommended";
import {mapState, mapActions} from 'vuex'
import ProjectArchiveButton from "./ProjectArchiveButton";
import {ValidationBehavior} from './ValidationBehavior'
import {AxiosErrorException} from '../admin/functions/axiosErrorException'
import ProjectSupplierSelector from "./ProjectSupplierSelector";
import PaymentCardOptionsButton from "./PaymentCardOptionsButton";
import ProjectEvents from "../ProjectEvents";
import UserPhoneStatus from "@projects/UserPhoneStatus";
import SupplierAgentInformation from "@projects/SupplierAgentInformation";
import UserEmailsSentList from "@components/profile_shared/UserEmailsSentList";
import DuePortfolioSupplierStats from "@components/supplier/DuePortfolioSupplierStats";
import ApplicantNotificationButton from "../projectsv2/ApplicantNotificationButton.vue";
import OsNotificationButton from "../projectsv2/OsNotificationButton.vue";
import userIdentityHelper from "@/helpers/userIdentityHelper";
import projectValidationHelper from "../../helpers/projectValidationHelper";
import formatHelper from "../mixins/formatHelper";
import swal from "sweetalert";
import UserIdentityVerification from '@components/profile_shared/UserIdentityVerification';
import {VMoney} from 'v-money'
import ClientMaxLoanAmountAllowedInput from "./ClientMaxLoanAmountAllowedInput.vue";
import creditStatusesHelper from "@mixins/creditStatusesHelper";
import {is} from "../../../src/views/admin/functions/userRoleBehavior.js";
import projectStatusesHelper from "@mixins/projectStatusesHelper.js"; 
import LoanScreenedButton from "./LoanScreenedButton.vue";
import LoanGeolocationComponent from "../projectsv2/components/LoanGeolocationComponent.vue";
import LoanRejectionButton from "../projectsv2/components/LoanRejectionButton.vue";
import AssignLoanResponsibles from "../projectsv2/components/AssignLoanResponsibles.vue";
import LoanRelationWApplicantIFC from "../projectsv2/components/LoanRelationWApplicantIFC.vue";

const PF_TAX_PROFILE = 0;
const PFAE_TAX_PROFILE = 1;

const PM_PERSON_TYPE = 0;
const PF_PFAE_PERSON_TYPE = 1;

const PFAE_PM_CROWDFUNDING_LOAN_TYPE = 2;
const PF_CROWDFUNDING_LOAN_TYPE = 1;

const maxCostWithoutPercent = 700000;
const minPercentage = "5%";

const PF_LOAN_OPTIONS = [
    { key: 'pfae_0_sat_link', value: "pfae_0_sat_link (syntage)" },
    { key: 'pf_1_applicant_address', value: "pf_1_applicant_address" },
    { key: 'pf_2_tech_address', value: "pf_2_tech_address" },
    { key: 'pf_3_loan_profile', value: "pf_3_loan_profile" },
    { key: 'pf_4_occupation', value: "pf_4_occupation" },
    { key: 'pf_5_job_profile', value: "pf_5_job_profile" },
    { key: 'pf_7_expenses', value: "pf_7_expenses" },
    { key: 'pf_8_loan_checkpoint', value: "pf_8_loan_checkpoint" },
    { key: 'pf_10_credit_acceptance', value: "pf_10_credit_acceptance" },
    { key: 'pf_11_guarantee_data', value: "pf_11_guarantee_data" },
    { key: 'pf_12_documents_and_identity', value: "pf_12_documents_and_identity" }
];
const PM_LOAN_OPTIONS = [
    { key: 'pm_2_business_address_confirmation', value: "pm_2_business_address_confirmation" },
    { key: 'pm_legal_rep_information', value: "pm_legal_rep_information" },
    { key: 'pm_3_personal_profile_address', value: "pm_3_personal_profile_address" },
    { key: 'pm_4_personal_profile_curp', value: "pm_4_personal_profile_curp" },
    { key: 'pm_5_personal_profile_sic_check', value: "pm_5_personal_profile_sic_check" },
    { key: 'pm_7_business_stakeholders', value: "pm_7_business_stakeholders" },
    { key: 'pm_8_personal_guarantees_confirmation', value: "pm_8_personal_guarantees_confirmation" },
    { key: 'pm_9_documents_and_identity', value: "pm_9_documents_and_identity" }
];

export default {
  name: "ProjectHeader",
  mixins: [
    userIdentityHelper,
    projectValidationHelper,
    formatHelper,
    creditStatusesHelper,
    projectStatusesHelper
  ],
  props: {
    relatedProjects: {
      type: Object,
      required: true
    },
    isNewPage: {
      type: Boolean,
      default: false
    }
  },
  directives: {money: VMoney},
  components: {
    ClientMaxLoanAmountAllowedInput,
    UserEmailsSentList,
    PaymentCardOptionsButton,
    ProjectSupplierSelector,
    ProjectArchiveButton,
    ButtonMarkProjectAsRecommended,
    ProjectFundingProgress,
    ProjectEvents,
    UserPhoneStatus,
    SupplierAgentInformation,
    DuePortfolioSupplierStats,
    ApplicantNotificationButton,
    OsNotificationButton,
    UserIdentityVerification,
    LoanScreenedButton,
    LoanGeolocationComponent,
    LoanRejectionButton,
    AssignLoanResponsibles,
    LoanRelationWApplicantIFC
  },
  async mounted() {
    await this.getSLASParams();
    await this.getRiskModelVersions();
  },
  computed: {
    isMoral() {
      try {
        return this.project.client.user.person_type === PM_PERSON_TYPE;
      } catch (e) {
        return false;
      }
    },
    step_options() {
      if(this.isMoral) {
          return this.PM_LOAN_OPTIONS;
      } else {
          return this.PF_LOAN_OPTIONS;
      }
    },
    isCreditRiskOrAdmin() {
      return is("admin", this.user.user_roles) || is("credit_risk", this.user.user_roles);
    },
    canSendOffer() {
      return (this.project.loan_proposal_timestamp == null && this.isCreditRiskOrAdmin 
              && this.project.finance.term != null
              && this.project.finance.financed_amount != null
              && this.project.finance.annual_interest_percentage != null
              && this.project.finance.monthly_payment != null
              && this.project.finance.annual_interest_percentage != null
            )
    },
    isProjectNotUndefined() {
      return typeof project !== undefined
    },
    ...mapState('projects', ['project']),
    personType() {
      try {
        let up = this.project.client.user.person_type;
        if (up === PM_PERSON_TYPE) {
          return "Persona Moral";
        } else {
          return "Persona Física";
          // return this.project.finance.crowdfunding_loan_type === PF_CROWDFUNDING_LOAN_TYPE ? "Persona Física" : "Persona Física con Actividad Empresarial";
        }
      } catch (e) {
        console.log(this.project)
      }
    },
    canReturnToSupplier() {
      if (this.project.status < 4 && this.project.resolution_date == null) {
        return true;
      }
      return false;
    },
    canReturnToLead() {
      return this.project.status === 2 && this.project.review_date != null;
    },
    canCloneProject() {
      return ( this.project.status === 4 
              || this.project.status === 5       
              || this.project.status === 6       
              || this.project.status === 7       
              || this.project.status === 8       
              || this.project.status === 9      
              || this.project.status === 10       
      );
    },
    canReturnToRisk() {
      return (
        this.project.status < 4
        && this.project.documentation_complete_date == null
        && (
          this.project.loan_request_step == "pm_8_personal_guarantees_confirmation"
          || this.project.loan_request_step == "pm_9_documents_and_identity"
          || this.project.loan_request_step == "pf_11_guarantee_data"
          || this.project.loan_request_step == "pf_12_documents_and_identity"
        )
      )
    },
    isNewApplicant() {
      return this.relatedProjects.total === 1;
    },
    hasRejectedProjects() {
      return this.relatedProjects.rejected.length > 0;
    },
    hasNotRejectedNotRunningProjects() {
      return this.relatedProjects.notRejected.length > 0 && this.relatedProjects.running.length === 0;
    },
    hasRunningProjects() {
      return this.relatedProjects.running.length > 0;
    },
    relatedProjectsList() {
      if (this.relatedProjects.total > 0) {
        let projs = [];
        projs.push.apply(projs, this.relatedProjects.rejected);
        projs.push.apply(projs, this.relatedProjects.notRejected);
        projs.push.apply(projs, this.relatedProjects.running);
        return projs;
      }
      return [];
    },
    showApplicantPasswordReminder() {
      return this.project.finance.loan_type === 1 && this.project.status === 1 && this.project.client.user.active === 0;
    },
    canApprove()
    {
      return this.project.status == 3 && this.project.approved_date == null;
    },
  },
  data: () => ({
    editLoanStep: false,
    PF_LOAN_OPTIONS: PF_LOAN_OPTIONS,
    PM_LOAN_OPTIONS: PM_LOAN_OPTIONS,
    stepSelected: null,
    showDropDownList: false,
    showDialogApprove: false,
    slas: {
      max_total_cost_amount_to_no_deposit_mxn: maxCostWithoutPercent,
      contract_public_notary_limit_udis: null,
      max_applicant_pf_financed_amount_udis: null,
      max_applicant_pm_financed_amount_udis: null,
    },
    money: {
      decimal: '.',
      thousands: ',',
      prefix: '',
      suffix: '',
      precision: 2,
      masked: false
    },
    udis: null,
    minPercentage: minPercentage,
    commentsPrompt: false,
    reasons: "",
    btnConfig: {
      type: "line",
      color: "primary",
      size: ""
    },
    createdId: null,
    riskModelVersions: null,
    showRejectReasonDialog: false,
  }),
  methods: {
    ...mapActions('projects', [
      'rejectProject',
      'approveProject',
      'preApproveProject',
      'publishProject',
      'generateContracts',
      'returnProjectToSupplier',
      'projectToLeadStatus',
      'requestApplicantOnboardingReminder'
    ]),
    async requestEmailToApplicant() {
      try {
        this.showLoading(true);
        await this.requestApplicantOnboardingReminder({
          userId: this.project.client.user.id,
          loanId: this.project.id,
          type: "activation"
        });
        this.showLoading(false);
      } catch (error) {
        console.log(error);
      }
    },
    saveMaxLoanAmountAllowedHandler() {

    },
    showAmortTab() {
      this.$emit("on-show-amort-tab")
    },
    // TODO-DELETE-IA 28/02/2024 ESTA FUNCION SE VA
    // async updateCreditStatus() {
    //   this.showDropDownList = false;
    //   try {
    //     let res = await axios.put(`/api/project/${this.project.id}/finance/credit-status`, {
    //       credit_status: this.project.finance.credit_status,
    //       project_id: this.project.id
    //     })
    //   } catch (e) {
    //     swal("Ups!", "Error al intentar guardar el estatus de cobranza!", "error")
    //   }
    // },
    goToClientCardSection() {
      window.open("/tarjetas/" + this.project.client.user.id_externo)
    },
    async preapprove() {
      await this.$emit('on-reload-project');
      // if (this.project.supplier.id == null) {
      //   swal("Atención", "No puede pre-aprobar el proyecto sin asignar proveedor!", "warning");
      //   return;
      // }

      await this.$emit('on-preapprove-request');
    },
    async approve() {
      await this.$emit('on-reload-project');
      
      // Sólo valida al OS sí se solicitó previamente
      if(this.project.finance.guarantee_required) {
        const guaranteesAreValid = await this.validateGuaranteesIdentities(this.project.id);
        if (!guaranteesAreValid) {
          swal("Ups!", "Para aprobar el proyecto, es necesario que la verificación de identidad de los Obligados Solidarios esté en estatus <<VERIFICADA>>, haber realizado su consulta de historial crediticio y que el OS esté verificado.", "warning");
          return;
        }
      }


      let validator = ValidationBehavior.approve(this.project);
      if (validator.valid) {
        //let res = await this.approveProject(this.project.id); NO DESCOMENTAR
        await this.$emit('on-approve-request');
        await this.createConektaAccount();
        await this.createStpAccount();
        if (this.reasons !== '') {
          await this.createJustifyNote();
        }
        this.showDialogApprove = false;
      } else {
          swal("Atención", ValidationBehavior.objectToStringErrors(validator.errors), "warning")
      }
    },
    async createConektaAccount() {
      try {
        await axios.post(`/api/conekta/v1/account/applicant/${this.project.client_id}`, {});
      } catch (error) {
        this.missingFieldsNotif(null, error.response.data.message);
      }
    },
    async createStpAccount() {
      await axios.post(`/api/stp/v1/account/applicantId/${this.project.client_id}`, {})
    },
    async requestLoanReject() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Rechazar crédito ${this.project.alias} - ${this.project.id}`,
        text: `¿Estás seguro que deseas rechazar el crédito? Esta acción es irreversible.`,
        acceptText: "Rechazar crédito",
        cancelText: 'Cancelar',
        accept: this.reject
      });
    },
    async reject() {
      if (confirm("¿Está seguro de rechazar el proyecto?")) {
        try {
          await this.rejectProject(this.project.id);
          swal("Ok!", "!Los cambios se realizaron correctamente!", "success")
        } catch (e) {
          swal("Upss!", "Hubo un error al rechazar el projecto", "error")
          console.error(e)
        }
      }
    },
    async publish() {
      await this.$emit('on-reload-project');
      const extraValidation = await this.runExtraValidations(this.project);

      if (!extraValidation.isValid) {
        swal("Ups!", extraValidation.errorText);
        return;
      }

      let validator = ValidationBehavior.publicProject(this.project)
      if (validator.valid) {
        this.requestPublishProject();
      } else {
        swal("Ups!", validator.errors, "error")
      }
    },
    requestPublishProject() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: `Publicar crédito ${this.project.alias} - ${this.project.id}`,
        text: `¿Estás seguro que deseas publicar el crédito en nuestro portal? El crédito estará disponible para fondeo.`,
        acceptText: "Publicar crédito",
        cancelText: 'Cancelar',
        accept: this.doPublishProject
      });
    },
    async doPublishProject() {
      try {
        await this.publishProject({
          id: this.project.id,
          first_payment_date: this.project.finance.first_payment_date
        });
        await this.$emit('on-reload-project');
        let successMessage = `¡El proyecto ${this.project.alias} - ${this.project.id} se publicó correctamente! \n
                              El proyecto se publicó con los siguientes parametros: \n
                              - Monto mínimo de inversión: ${this.mxnFormat(this.project.finance.minimal_investment)} \n
                              - Inversión por RedGirasol: ${this.mxnFormat(this.project.finance.financed_amount * 0.01)}`;
        swal("Ok!", successMessage, "success");
      } catch (e) {
        console.error(e)
        swal("Ups!", AxiosErrorException(e), "error")
      }
    },
    async runExtraValidations(project) {
      let errors = [];

      // Validar Art47 CUITF
      const art47Status = await this.validateLoanLimitsCUITF47(project.id, project.client.id);
      if(!art47Status.is_valid) {
        if(art47Status.error != null) {
          errors.push("El solicitante no cumple con los límites de CUITF 47. No se ha encontrado información de límites. \n" + art47Status.error);
        } else {
          errors.push(`
          El solicitante no cumple con los límites de CUITF 47. \n
           - Límite ${this.mxnFormat(art47Status.max_limit)}. \n
           - Monto solicitado ${this.mxnFormat(art47Status.current_financed_amount)}. \n
           - Monto ya publicado ${this.mxnFormat(art47Status.auxFinancedAmount)}. \n
           - PIDS publicados: ${art47Status.project_ids}. \n
          `);
        }
      }

      // Validar identificación de identidad
      const identityStatus = await this.getUserIdentityStatus(project.client.user.id);
      if (identityStatus != 1) {
        errors.push(this.handleIdentityStatus(identityStatus, true));
      }

      // Sí es proyecto tipo SFV (finance.loan_type == 1)
      // if (project.finance.loan_type == 1) {
      //   const isValid = await this.validateInitialPayment(project.id);
      //   if (!isValid.is_valid) {
      //     errors.push("No se ha confirmado el pago inicial. Revisar TRX C262 con estatus diferente a 1.");
      //   }
      // }

      // const finalBalance = await this.validateRgFinalBalance(project.id);
      // if (!finalBalance.can_invest) {
      //   const moneyNeeded = (finalBalance.minimum_to_invest - finalBalance.rg_available_money);
      //   errors.push(`RedGirasol no tiene saldo suficiente para para invertir en este proyecto. Saldo actual: ${this.mxnFormat(finalBalance.rg_available_money)}, faltante: ${this.mxnFormat(moneyNeeded)} .`);
      // }

      const isProjectValid = await this.validateLoanGuarantee(project.id);
      if (!isProjectValid) {
        errors.push("El proyecto no cuenta con garantía de crédito.");
      } 

      let errorStr = "";
      if (errors.length > 0) {
        errors.forEach(err => {
          errorStr += err + "\n";
        });
      }

      return {
        isValid: errors.length == 0,
        errors: errors,
        errorText: errorStr
      }

    },
    returnToSupplierRequest() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirme operación`,
        text: '¿Está seguro de ejecutar el regreso del proyecto al proveedor?',
        acceptText: "Ejecutar retorno",
        cancelText: "Cancelar",
        accept: this.returnToSupplier
      });
    },
    async returnToSupplier() {
      try {
        await this.returnProjectToSupplier(this.project.id);
        this.saveSuccessNotif();
      } catch (err) {
        console.error(err);
        let dd = err.response.data;
        let mssg = `${err}, Mssg: ${dd}`;
        this.errorNotifDialog("Error en operación", mssg);
      }
    },
    async reactiveProject(id) {
      if (confirm("Estas seguro de reactivar el proyecto?")) {
        try {
          let res = await axios.post("/api/project/" + this.project.id + "/reactive")
          swal("Ok!", "El proyecto se ha reactivado correctamente!", "success");
          this.project.status = res.data.status
          this.project.status_named = res.data.status_named
          this.project.resolution_date = null;
        } catch (ex) {
          console.log(ex)
        }
      }
    },

    returnToLeadRequest() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirme operación`,
        text: '¿Está seguro de ejecutar el regreso de la pre-solicitud al proveedor?',
        acceptText: "Ejecutar retorno",
        cancelText: "Cancelar",
        accept: this.returnprojectToLeadStatus
      });
    },

    async returnprojectToLeadStatus() {
      try {
        await this.projectToLeadStatus(this.project.id);
        this.saveSuccessNotif();
      } catch (err) {
        console.error(err);
        let dd = err.response.data;
        let mssg = `${err}, Mssg: ${dd}`;
        this.errorNotifDialog("Error en operación", mssg);
      }
    },

    statusName: function () {
      let desc = "";
      if (this.project.resolution_date != null) {
        return "Archivado";
      }

      if (this.project.status != null) {
        switch (this.project.status) {
          case 1:
            desc += "En proceso de creación"
            break;
          case 2:
            desc += "En revisión";
            break;
          case 3:
            desc += "Pre-aprobado";
            break;
          case 4:
            desc += "Aprobado";
            break;
          case 5:
            desc += "En fondeo";
            break;
          case 6:
            desc += "En firma de contratos";
            break;
          case 7:
            desc += "En instalación";
            break;
          case 8:
            desc += "Entregado";
            break;
          case 9:
            desc += "Rechazado";
            break;
          case 10:
            desc += "Reembolsado";
            break;
          default:
            desc += "Pendiente";
            break;
        }
      }
      return desc;
    },
    validateProjectTotalCost() {
      if (this.project.finance.loan_type == 1 && this.project.finance.total_cost > this.slas.max_total_cost_amount_to_no_deposit_mxn
          && this.project.finance.deposit_percentage === 0.0) {
        this.commentsPrompt = true;
        return false;
      }
      return true;
    },
    async getSLASParams() {
      let slasObjects = [
        'max_total_cost_amount_to_no_deposit_mxn', 
        'contract_public_notary_limit_udis',
        'max_applicant_pf_financed_amount_udis',
        'max_applicant_pm_financed_amount_udis'
      ];
      let slasParams = "with[]=" + slasObjects.join("&with[]=");
      let slasRes = await axios.get(`/api/v1/forms/getSlasValues?${slasParams}`);
      this.slas = slasRes.data;


      let collectionsObjects = ['banxicoUdis'];
      let params = "with[]=" + collectionsObjects.join("&with[]=");
      let res = await axios.get(`/api/v1/forms/getFormCollections?${params}`);
      this.udis = res.data.banxicoUdis.udis;
    },

    async createJustifyNote() {
      try {
        let payload = {
          note: this.reasons,
          is_private: 1,
          project_id: this.project.id,
          sendIncompleteFiles: 0
        };
        const res = await axios.post(`/api/project/${this.project.id}/notes`, payload);
        this.commentsPrompt = false;
        this.reasons = '';
      } catch (e) {
        console.error(e);
      }
    },
    async confirmApproveHandler() {

      // Validar identificación de identidad
      const identityStatus = await this.getUserIdentityStatus(this.project.client.user.id);
      if(identityStatus != 1){
        this.handleIdentityStatus(identityStatus);
        return;
      }

      if (!this.validateProjectTotalCost()) {
        return;
      }

      // Valida el saldo insoluto del solicitante vs el monto autorizado máximo.
      const debitBalance = await this.validateDebitBalance(this.project.id);
      if (!debitBalance.can_approve) {
        if(debitBalance.hasOwnProperty('has_error')) {
          swal("Ups!", debitBalance.has_error, "error");
        } else {
          swal("Ups!", `El proyecto no puede ser aprobado porque el monto de préstamo excede del autorizado. Saldo insoluto: ${this.mxnFormat(debitBalance.debit_balance)}. Monto a financiar: ${this.mxnFormat(debitBalance.finance_amount)}. Monto autorizado: ${this.mxnFormat(debitBalance.max_loan_amount_allowed_mxn)}`, "error");
        }
        this.showDialogApprove = false;
        return;
      }

      // Valida que el financed_amount no sea mayor al monto en udis máximo
      if(this.project.finance.crowdfunding_loan_type != null) {
        let slaSelected = this.project.finance.crowdfunding_loan_type == 1 ? this.slas.max_applicant_pf_financed_amount_udis : this.slas.max_applicant_pm_financed_amount_udis;
        let minUdisAmountForPersonType = await this.validateProjectAmountUdis(this.project.finance, this.udis, slaSelected);
        if (!minUdisAmountForPersonType) {
          swal("Ups!", `El proyecto no puede ser aprobado porque el monto a financiar excede del autorizado. Monto a financiar: ${this.mxnFormat(this.project.finance.financed_amount)}, monto máximo: ${this.mxnFormat((this.udis * slaSelected).toFixed(2))}`, "error");
          this.showDialogApprove = false;
          return;
        }
      } else {
        swal("Ups!", "No se ha podido validar el monto máximo a financiar para el solicitante, falta definir campo Economicos/Financiamiento colectivo (crowdfunding_loan_type)", "error");
        this.showDialogApprove = false;
        return;
      }

      try {
        /*let latestPreApproveModelResult = await RiskModel.preApprove()
          .find(this.project.id, this.project.client.fiscal.rfc);

        const {data} = await axios.get(`/api/risk-model/pid/${this.project.id}/approve/form`);
        let payload = data;

        payload['project_id'] = this.project.id;
        payload['rfc'] = this.project.client.fiscal.rfc;
        payload['pre_approve_result'] = latestPreApproveModelResult.score;

        await RiskModel.approve()
          .validate(this.project.id, this.project.client.fiscal.rfc, payload);*/

        // Validar datos para publicar.
        let validator = ValidationBehavior.publicProject(this.project)
        if (validator.valid) {
          await this.approve()
        } else {
          swal("Ups!", validator.errors, "error")
        }
      } catch (e) {
        console.log(e)
        await swal("Error", e.message, "error")
      }
    },
    cloneProjectRequest() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirme operación`,
        text: `¿Está seguro de clonar el proyecto ${this.project.id}?`,
        acceptText: "Clonar",
        cancelText: "Cancelar",
        accept: this.doCloneProject
      });
    },
    async doCloneProject() {
      try {
        const res = await axios.post(`/api/project/${this.project.id}/clone-project`);
        console.log(res.data);
        this.createdId = res.data.id;
        this.formSubmitted();
        this.saveSuccessNotif();
      } catch (err) {
        console.error(err);
        let dd = err.response.data;
        let mssg = `${err}, Mssg: ${dd}`;
        console.error(mssg);
        this.errorNotifDialog("Error en operación", "Algo salió mal, consulte la consola para saber más.");
      }
    },
    async formSubmitted(){
      let mssg = "Tu proyecto ha sido clonado, y está en revisión para ser aprobado. ";
      mssg += `El ID de tu proyecto es: ${this.createdId}.`;
      this.$vs.dialog({
        color: "success",
        type: "confirm",
        title: "Proyecto clonado correctamente",
        text: mssg,
        acceptText: "Ver solicitud",
        cancelText: 'Finalizar',
        accept: this.goToProject
      })
    },
    goToProject() {
      this.$router.replace({
        name: "Detalle de proyecto",
        params: { id: this.createdId }
      });
    },
    async getRiskModelVersions() {
      try {
        const {data} = await axios.get('/api/risk-model/versions');
        this.riskModelVersions = data;
      } catch (error) {
        console.log(error);
      }
    },
    translateRiskModelVersions(risk_model_version) {
      if (this.riskModelVersions) {
        const version = this.riskModelVersions.find(version => version.id === risk_model_version);
        return version ? version.name : '';
      }
      return '';
    },
    async requestPostLoanOffer() {
      await this.$emit('on-reload-project');
      // Se ejecutan las mismas validaciones que para publicar.
      const extraValidation = await this.runExtraValidations(this.project);

      if (!extraValidation.isValid) {
        swal("Ups!", extraValidation.errorText);
        return;
      }

      // Se ejecutan las mismas validaciones que para publicar.
      let validator = ValidationBehavior.publicProject(this.project)
      if (validator.valid) {
        this.$vs.dialog({
          color: "warning",
          type: "confirm",
          title: "Enviar oferta de crédito",
          text: "Se enviará una nueva oferta de crédito al solicitante para que la acepte. ¿Desea continuar?",
          acceptText: "Enviar oferta de crédito",
          cancelText: 'Cerrar',
          accept: this.postLoanOffer
        });
      } else {
        swal("Ups!", validator.errors, "error")
      }
    }, 
    async postLoanOffer() {
      this.showLoading(true);
      try {
        await axios.post(`/api/loan-onboarding/post/${this.project.id}/send-loan-offer`);
        this.showLoading(false);
        swal("Oferta de crédito enviada", "La oferta de crédito ha sido enviada al cliente", "success");
      } catch (err) {
        this.showLoading(false);
        swal("Error", err.response.data.error, "error");
      }
    },
    async postLoanReviewDateWithoutDocuments() {
      this.showLoading(true);
      try {
        await axios.post(`/api/loan-onboarding/post/${this.project.id}/set-loan-review-date`);
        swal("Solicitud revisada", "Se validó la información de la solicitud y se ejecutó el modelo. Sin documentación", "success");
        this.showLoading(false);
      } catch (err) {
        this.showLoading(false);
        swal("Error", "Hubo un error al revisar la solicitud.", "error");
      }
    },
    requestReturnToRisk()
    {
      this.$vs.dialog({
        color: "warning",
        type: "confirm",
        title: "Enviar a riesgo crediticio",
        text: "Se enviará la solicitud a revisión con el equipo de riesgo crediticio. ¿Desea continuar?",
        acceptText: "Enviar a riesgo crediticio",
        cancelText: 'Cerrar',
        accept: this.doRequestReturnToRisk
      })
    },
    async doRequestReturnToRisk() {
      this.showLoading(true);
      try {
        await axios.post(`/api/loan/post/${this.project.id}/send-to-credit-risk`);
        this.showLoading(false);
        swal("Solicitud enviada a riesgo crediticio", "La solicitud ha sido enviada a revisión con el equipo de riesgo crediticio", "success");
      } catch (err) {
        this.showLoading(false);
        swal("Error", "Hubo un error al enviar la solicitud a riesgo crediticio", "error");
      }
    },
    requestUpdateLoanStep() {
      this.$vs.dialog({
          type: 'confirm',
          color: 'warning',
          title: 'Actualizar step de solicitud',
          text: `¿Estás seguro de actualizar el paso de solicitud a ${this.stepSelected}?`,
          acceptText: 'Aceptar',
          accept: this.doUpdateLoanStep,
          cancelText: 'Cancelar',
          cancel: false
      });
    },
    async doUpdateLoanStep() {
      try {
          this.showLoading(true, "Actualizando paso de solicitud...");
          await axios.put(`/api/loan/put/update-loan-step`, {
              step: this.stepSelected,
              loan_id: this.project.id
          });
          this.editLoanStep = false;
          this.showLoading(false);
          window.location.reload();
      } catch (error) {
          console.log(error);
          this.failedOperationNotif();
      }
    },
    async requestNewGuaranteeForLoan() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: 'Solicitar nuevo Obligado Solidario',
        text: `¿Estás seguro de solicitar un nuevo Obligado Solidario para la solicitud?`,
        acceptText: 'Aceptar',
        accept: this.doRequestNewGuaranteeForLoan,
        cancelText: 'Cancelar',
        cancel: false
      });
    },
    async doRequestNewGuaranteeForLoan() {
      try {
        this.showLoading(true, "Solicitando nuevo Obligado Solidario...");
        await axios.post(`/api/guarantee/post/onboarding/request-guarantee`, {
          loan_id: this.project.id
        });
        this.showLoading(false);
        swal("Ok!", "Se ha solicitado un nuevo Obligado Solidario para la solicitud.", "success");
        window.location.reload();
      } catch (error) {
        console.log(error);
        this.failedOperationNotif();
      }
    }
  }
}
</script>

<style scoped>

</style>
